import { API_BASE } from '../lib/env';
import { getItem } from '../lib/storage';

type HttpInit = Omit<RequestInit, 'headers' | 'body'> & {
  body?: unknown;
  auth?: boolean;
};

export class HttpError extends Error {
  constructor(
    public status: number,
    public payload: unknown,
  ) {
    super(`HTTP ${status}`);
  }
}

export async function http<T>(path: string, init: HttpInit = {}): Promise<T> {
  const { body, auth = false, ...rest } = init;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (auth) {
    const token = getItem('accessToken');
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  const requestInit: RequestInit = { ...rest, headers };
  if (body !== undefined) requestInit.body = JSON.stringify(body);
  const response = await fetch(`${API_BASE}${path}`, requestInit);
  const payload = (await response.json().catch(() => null)) as unknown;
  if (!response.ok) throw new HttpError(response.status, payload);
  return payload as T;
}
